// HomePage.js
import React, { useState, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import weddingPhoto from '../mikerry.jpg';
import settings from '../config/settings.json';
// Unused imports - kept for potential future use with buildScript
// import { collection, doc, setDoc, getDocs, query } from 'firebase/firestore';
// import { db } from '../firebaseConfig';
import MikerryMerge from './components/MikerryLogo';

function TimelineItem({ event, index, isLeft }) {
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  return (
    <div className="timeline-row">
      <motion.div
        ref={ref}
        className={`timeline-box ${isLeft ? 'left' : 'right'}`}
        initial="hidden"
        animate={controls}
        variants={{
          visible: {
            opacity: 1,
            x: 0,
            transition: { type: "spring", bounce: 0.2, duration: 0.6 }
          },
          hidden: {
            opacity: 0,
            x: isLeft ? -50 : 50
          }
        }}
      >
        {event.image && (
          <div className="timeline-image-wrapper">
            <img 
              src={event.image} 
              alt={event.text}
              className="timeline-image"
              loading="lazy"
            />
          </div>
        )}
        <div className="timeline-content-wrapper">
          <div className="timeline-date">{event.date}</div>
          <div className="timeline-text">{event.text}</div>
        </div>
        <div className="timeline-connector"></div>
      </motion.div>
    </div>
  );
}

function HomePage() {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  // Timeline animation controls
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  function calculateTimeLeft() {
    const weddingDate = new Date(settings.ceremonyTime).getTime();
    const now = new Date().getTime();
    const difference = weddingDate - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  // Unused function - kept for potential future use
  // async function buildScript(){
  //   //inviteList.json
  // 
  //   const invitesRef = collection(db, "invites");
  // 
  //   const inviteList = (await import('../config/inviteList.json')).default;
  //   
  //   if (inviteList.length > 0) {
  //     console.log("Invite list exists.");
  //     return;
  //   }
  //   inviteList.forEach(async (invite) => {
  //     const docRef = doc(invitesRef, invite.name);
  //     await setDoc(docRef, {
  //       name: invite.name,
  //       phoneNumber: invite.phoneNumber,
  //       rsvp: null,
  //       mealChoice: invite.mealChoice,
  //       canAlsoEdit:invite.canAlsoEdit,
  //     });
  //   });
  // 
  //   console.log("Invite list added to Firebase.");
  // 
  //   //check if menu items exist in firebase
  // 
  //   const menuItemsRef = collection(db, "menuItems");
  //   const menuItemsQuery = query(menuItemsRef);
  //   const menuItemsSnapshot = await getDocs(menuItemsQuery);
  //   if (!menuItemsSnapshot.empty) {
  //     console.log("Menu items exist.");
  //     return;
  //   }
  // 
  //   const menuItems = (await import('../config/mealOptions.json')).default;
  //   const menuRef = collection(db, "menuItems");
  //   
  //   menuItems.forEach(async (menuItem) => {
  //     const docRef = doc(menuRef, menuItem.name);
  //     await setDoc(docRef, {
  //       type: menuItem.type,
  //       course: menuItem.course,
  //       options: menuItem.options.map(option => ({
  //         name: option.name,
  //         description: option.description,
  //         image: option.image,
  //         vegetarian: option.vegetarian,
  //         vegan: option.vegan,
  //         glutenFree: option.glutenFree,
  //         dairyFree: option.dairyFree,
  //         nutFree: option.nutFree,
  //         eggFree: option.eggFree,
  //         shellfishFree: option.shellfishFree,
  //         fishFree: option.fishFree,
  //         soyFree: option.soyFree,
  //         celeryFree: option.celeryFree,
  //         mustardFree: option.mustardFree,
  //         sesameFree: option.sesameFree,
  //         sulphiteFree: option.sulphiteFree,
  //         kosher: option.kosher,
  //         halal: option.halal
  //       }))
  //     });
  //   });
  // 
  // }

  return (
    <header className="App-header">
      <MikerryMerge />
      <h1 className="wedding-title fade-in-up">
        <span style={{ fontFamily: 'var(--font-heading)' }}>Mike</span>
        <span style={{ 
          fontFamily: 'var(--font-script)', 
          fontSize: '0.5em', 
          margin: '0 0.3em',
          color: 'var(--accent-cream)',
          fontWeight: 'normal',
          textTransform: 'none',
          letterSpacing: 'normal'
        }}>and</span>
        <span style={{ fontFamily: 'var(--font-heading)' }}>Kerry's</span>
        <div style={{ 
          fontFamily: 'var(--font-body)', 
          fontSize: '0.4em', 
          fontWeight: 'normal',
          textTransform: 'none',
          letterSpacing: '0.5px',
          marginTop: '0.5em',
          color: 'var(--text-secondary)'
        }}>Wedding</div>
      </h1>
      <div className="photo-container glow fade-in-up">
        <img src={weddingPhoto} className="wedding-photo" alt="Mike and Kerry's Wedding" />
      </div>
      <div className="countdown-timer fade-in-up">
        <h2>Countdown to Our Special Day</h2>
        <p>
          {timeLeft.days} Days, {timeLeft.hours} Hours, {timeLeft.minutes} Minutes, {timeLeft.seconds} Seconds
        </p>
      </div>
      <section ref={ref} className="timeline-section fade-in-up">
        <h2 className="timeline-title">Our Journey</h2>
        <div className="timeline">
          {[
            { date: "November 2010", text: "We first met", image: "/us/WhatsApp Image 2026-01-03 at 20.45.31 (3).jpeg" },
            { date: "January 2011", text: "We made it official", image: "/us/WhatsApp Image 2026-01-03 at 20.45.31 (2).jpeg" },
            { date: "June 2011", text: "We moved in together", image: "/us/WhatsApp Image 2026-01-03 at 20.45.31 (1).jpeg" },
            { date: "June 2017", text: "We bought our home", image: "/us/WhatsApp Image 2026-01-03 at 20.45.31.jpeg" },
            { date: "July 2018", text: "Josh was born", image: "/us/WhatsApp Image 2026-01-03 at 20.45.30.jpeg" },
            { date: "June 2023", text: "We got engaged", image: "/us/engaged.jpeg" },
            { date: "March 2024", text: "Jacob was born", image: "/us/WhatsApp Image 2026-01-03 at 20.46.04.jpeg" },
            { date: "June 2026", text: "We're getting married!", image: "/us/WhatsApp Image 2026-01-03 at 20.46.39.jpeg" }
          ].map((event, index) => (
            <TimelineItem key={index} event={event} index={index} isLeft={index % 2 === 0} />
          ))}
        </div>
      </section>
    </header>
  );
}

export default HomePage;